<template>
  <div class="vue-flash-messages">
    <flash-messages />
  </div>
</template>

<script setup>
  import { each, includes } from 'lodash-es'
  import FlashMessages from '@components/flash_messages/FlashMessages.vue'
  import FlashMessageService from '@services/FlashMessages'
  import { onMounted } from 'vue'

  onMounted(() => {
    const int = setInterval(function() {
      if (window.gon!=undefined) {
        clearInterval(int)
        
        let gon = window.gon
        if (gon.flashMessages && gon.flashMessages.length > 0) {
          each(gon.flashMessages, msg => {
            if (msg && Array.isArray(msg) && msg.length > 1) {
              // split on ':' to allow for more sophisticated options to be passed through
              let opts = msg[0].split(':')
              let method = opts[0]
              opts.splice(0, 1)
              let optsDict = {}

              if (opts.length > 0) {
                if (includes(opts, 'indefinite')) {
                  optsDict.timeout = 0
                  optsDict.clickClose = false
                }

                // put any more options you want to pass through here
              }
              // filter messages to supported types
              if (FlashMessageService.validMessageTypes.includes(method)) {
                FlashMessageService[method](msg[1], null, optsDict)
              } 
            }
          })
          gon.flashMessages = []
        }
      }
    },100)
  })
</script>